'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconArrowOutCircle, iconArrowOutCircleTag } from '@ni/nimble-components/dist/esm/icons/arrow-out-circle';
import { wrap } from '../../utilities/react-wrapper';

export type { IconArrowOutCircle };
export { iconArrowOutCircleTag };
export const NimbleIconArrowOutCircle = wrap(IconArrowOutCircle);